module.exports = __webpack_public_path__ + "7aa7d7af70bb77d369c78a46b23751ff.pdf";